import styles from './index.module.scss'
import { Anchor } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { list } from '../../artical';
const { Link } = Anchor;
const Card2 = () => {
  const [searchParams] = useSearchParams();

  const [dataList] = useState(list)
  const [itemInfo,setItemInfo] = useState({})

  useEffect(()=>{

    const key = searchParams.get("key");
    dataList.map(items => {
      if(items.key===key){
        setItemInfo(items)
      }
    })
  },[searchParams])
  const onChange = (link) => {
    // console.log('Anchor:OnChange', link);
  };

  return (
    <div className={`${styles.card} w-1260 flex`}>
      <div className={`${styles.menuLeft}`}>
        <Anchor className={`${styles.list}`}  onChange={onChange}>
          {
            itemInfo?.anchorList?.map((items, index) => (
              <Link key={index} className={`${styles.item}`} href={items.href} title={items.title} />
            ))
          }
        </Anchor>
      </div>
      <div className={`${styles.menuRight}`}>
        {
          itemInfo?.contentList?.map((item, index) => (
            <div id={item?.id} key={index}>
              {
                item.subTitle? (
                  <div className={`${styles.subtitle}`}>{item.subTitle}</div>
                ): null
              }
              {
                item?.subChildren?(
                  item.subChildren.map((subItem, index2) =>
                    <div key={subItem.type+index2} className={`${styles.content}`}>
                      {
                        subItem.type === 'text' ? <div>{subItem.text}</div>:null
                      }
                      {
                        subItem.type === 'img' ? (
                          <div>
                            <img src={subItem.text}/>
                            {
                              subItem.imgNotice ? <div style={{textAlign:'center',marginTop: '4px',color: '#6B6B6B'}}>{subItem.imgNotice}</div>:null
                            }
                          </div>
                        ):null
                      }
                      {
                        subItem.type === 'mix' ? (
                          <>
                            {
                              subItem.text? (
                                <span>{subItem.text}</span>
                              ) : null
                            }

                            {
                              subItem.aText? (
                                <a target="_blank" style={{textDecoration: 'underline',color: '#fff',margin: '0 4px'}} href={subItem.aLink}> {subItem.aText}</a>
                              ) : null
                            }

                            {
                              subItem.text2? (
                                <span>{subItem.text2}</span>
                              ) : null
                            }

                          </>
                        ) : null
                      }
                    </div>
                  )
                ) : null
              }
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default Card2